import { LanguageService } from '../../../commons/services/languages.service';
import Language from '../../../commons/entities/language';

export function languageServiceFactory(languageService: LanguageService): () => Promise<Language[]> {
  return () => languageService.loadSystemLanguages().toPromise();
}
